<script lang="ts" setup>

	const props = defineProps<{
		title: string;
		value: string;
		isSelected: boolean;
	}>();

	const emit = defineEmits(['onColumnClick']);

	const handleOnClick = () => emit('onColumnClick', props.value);

</script>

<template>
	<th :class="{'highlight-column' : isSelected}"
	    scope="col"
	    :colspan="1"
	    :data-column="value"
	    @click="handleOnClick">

		<span>{{ title }}</span>
	</th>
</template>
